import { useContext, useEffect, useState } from 'react';
import { SessionContextDto } from '../contexts/dtos/SessionContextDto';
import { SessionContext } from '../contexts/SessionContext';

function useDetectIsLogged() {
  const { state } = useContext(SessionContext);
  const isLogged = state?.bearerToken !== '';
  return isLogged;
}

function useDetectIsAdmin() {
  const { state } = useContext(SessionContext);
  const isLogged = state?.bearerToken !== '';
  return isLogged && state?.userRoles?.filter((x) => x.role === 100)?.length > 0;
}

function useGetUserDetails() {
  const { state } = useContext(SessionContext);
  const [user, setUser] = useState(new SessionContextDto());
  // console.log('UserDetails:', user);
  useEffect(() => {
    setUser(state);
  }, [state]);
  return user;
}
export { useDetectIsLogged, useGetUserDetails, useDetectIsAdmin };
